import { render } from "./BaseSelectCustom.vue?vue&type=template&id=1493e6e1&ts=true"
import script from "./BaseSelectCustom.vue?vue&type=script&lang=ts"
export * from "./BaseSelectCustom.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__